import dayjs from 'dayjs'
import Vue from 'vue'
import i18n from '@/plugins/i18n'

// dateOfBirth in dd/mm/yyyy format
const calculateAge = (dateOfBirth, returnShortVersion = false) => {
  const yearDifference = dayjs().diff(dayjs(dateOfBirth, Vue.prototype.$date.legacyFormatDateOnly), 'year')

  if (yearDifference > 0 && !returnShortVersion) {
    return i18n.tc('feedback.yearsOld', yearDifference)
  }

  const monthDifference = dayjs().diff(dayjs(dateOfBirth, Vue.prototype.$date.legacyFormatDateOnly), 'month')

  if (monthDifference > 0 && !returnShortVersion) {
    return i18n.tc('feedback.monthOld', monthDifference)
  }

  const dayDifference = dayjs().diff(dayjs(dateOfBirth, Vue.prototype.$date.legacyFormatDateOnly), 'day')

  if (!returnShortVersion) {
    if (dayDifference > 0) {
      return i18n.tc('feedback.dayOld', dayDifference)
    } else {
      return i18n.t('feedback.justBorn')
    }
  } else {
    let ageString = ''

    if (yearDifference) {
      ageString += `${yearDifference}y `
    }

    if (monthDifference) {
      ageString += `${monthDifference}m `
    }

    if (dayDifference) {
      ageString += `${dayDifference}d `
    }

    return ageString
  }
}

export const calculateYearsMonthsDays = dateOfBirth => {
  let dob = dayjs(dateOfBirth, Vue.prototype.$date.legacyFormatDateOnly)

  const yearDifference = dayjs().diff(dob, 'year')

  dob = dob.add(yearDifference, 'year')

  const monthDifference = dayjs().diff(dob, 'month')

  dob = dob.add(monthDifference, 'month')

  const dayDifference = dayjs().diff(dob, 'day')

  let ageString = ''

  if (yearDifference) {
    ageString += `${yearDifference}y `
  }

  if (monthDifference) {
    ageString += `${monthDifference}m `
  }

  if (dayDifference) {
    ageString += `${dayDifference}d `
  }

  return ageString
}

export default calculateAge
